// @flow
import React, { Component } from 'react';
import 'react-rangeslider/lib/index.css';
import 'react-responsive-modal/styles.css';
import '../../../webjam/components/custom.css';
import "react-tabs/style/react-tabs.css";
import { connect } from '../../../base/redux';
import { translate } from '../../../base/i18n';
import axios from 'axios';
import { FEATURE_CUSTOM_REDUX_V3 } from '../../constant';
import {
    FEATURE_CUSTOM_REDUX,
    FEATURE_CUSTOM_REDUX_V2
} from "../../../customise/constant"
import ModalDialog, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';

import {
    setHostTabData,
    setHostTabReload,
    showApiLoader,
    clickAutoMakeHost,
    setAutoMakeHost,
    setHostInitWait,
    setRoomorIpAddress,
    hideApiLoader
} from '../../../customise/redux/tool-webjam/actions';
import Toast from 'react-simple-toasts';

import { getActiveSession } from '../../../recording';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { thirdPartyMakeHostApi } from '../../welcome-dashboard/Request.d';
import { sendAnalytics } from '../../../analytics';
import { apiVersion } from '../../welcome-dashboard/Utils';
import config from '../../config';
const { socket_endpoint } = config;
import { Translate } from '../../../webjam/language';
import { messages } from '../../welcome-dashboard/messages';
import { isNumeric } from 'jquery';
import { dispatch, getBaseConfig, getStore, SaveLog, sleep, _ValidateIPaddress } from '../../Utils';
import { socketEmit, socketOn } from '../../../../../socket';
import { PARTICIPANT_ROLE, getLocalParticipant, getParticipantCount, getRemoteParticipants, isLocalParticipantModerator } from '../../../base/participants';
import { sendData } from '../../../webjam/websocket';
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from '../../../webjam/constant';
import { setHostButtonAction } from '../../redux/tool-webjam-v2/actions';
import { setIsEventRequestingLoader } from '../../redux/tool-webjam-v3/actions';
import { showAppToast } from '../../../webjam/helper';
let selectedUniqueId;
import cross from './../../../webjam/components/img/cross.png';
import { Snackbar, Slide } from '@mui/material';
import { ct } from '../../constant-Utils';

function TransitionRight(props) {
    return <Slide {...props} direction="right" />;
}

class ManageHost extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isAddressIP: false,
            ipNewroom: '',
            showNewRoomModal: false,
            showInfo: false,
            isAutoManageHostClicked: true,
            makeHostUniqueId: '',
            initialWait: true,
            showHostRefresh: false,
            automaticMakeHost: true,
            isUserConfirmed: false,
            showConfirmModal: false,
            transition: undefined,
            remoteUserInfo: {
                authorizedUser: {},
                newHostUser: {}
            }
        }
    }

    componentDidMount() {
        socketOn("auto_host_return", (data) => {
            console.log('auto_host_return data =>', data)
            console.log('auto_host_return data.actionPerformed =>', data.actionPerformed)
            const {
                roomorIpAddress,
                usersData,
                getLocalParticipant,
                conferenceJoined,
                isModerator
            } = this.props;

            if (conferenceJoined) {
                // hide current AI pop
                if (data.location == CURRENT_ROOM_LOCATION || roomorIpAddress == data.room) {
                    this.setState({
                        isUserConfirmed: false,
                        showConfirmModal: false
                    })
                }

                if (data.hasOwnProperty("autohost")
                    && usersData
                    && (data.location == CURRENT_ROOM_LOCATION || roomorIpAddress == data.room)) {

                    if (data.autohost) {
                        sessionStorage.setItem("uniqueID", localStorage.getItem("uniqueID"));
                    } else {
                        sessionStorage.removeItem("uniqueID");
                    }

                    if (!data.hasOwnProperty("actionPerformed") || (data.hasOwnProperty("actionPerformed") && data.actionPerformed != "manualMakeHost")) {
                        dispatch(clickAutoMakeHost({ clickedAutoMakeHost: data.autohost }, 'Manage Host auto_host_return'));
                    }

                    console.log('data.actionPerformed 0 =>', data.actionPerformed, data.jitsiId, getLocalParticipant.id)
                    // set disabled state all users can't click on make host button and auto manage host checkbox
                    if (data.hasOwnProperty("actionPerformed") && data.jitsiId != getLocalParticipant.id) {
                        console.log('data.actionPerformed 1 =>', data.actionPerformed)
                        if (data.actionPerformed == "manualMakeHost") {
                            console.log('data.actionPerformed 1.1 =>')
                            dispatch(setHostButtonAction(true))
                            dispatch(clickAutoMakeHost({ clickedAutoMakeHost: false }, 'manualMakeHost auto_host_return others'));
                            this.makeHostMessages(data)
                        }

                        if (data.actionPerformed == "autoMakeHost") {
                            console.log('data.actionPerformed 1.2 =>')
                            if (data.autohost) {
                                showAppToast(ct("rta-trmc.mixer.manageHostEnabledBy") + " " + data.actionByUser + '.', 10000);
                            } else {
                                showAppToast(ct("rta-trmc.mixer.manageHostDisabledBy") + " " + data.actionByUser + '.', 10000);
                            }
                        }

                        if (data.actionPerformed == "autoMakeHostRequest") {
                            console.log('data.actionPerformed 1.3 =>')
                            dispatch(setHostButtonAction(true))
                            // showAppToast(`Auto Manage Host will start in 10 to 20 seconds so make host button will be disabled for some time.`, 15000);
                            this.makeHostMessages(data)
                        }
                    } else if (data.hasOwnProperty("actionPerformed") && data.jitsiId == getLocalParticipant.id) {
                        console.log('data.actionPerformed 2 =>', data.actionPerformed)
                        if (data.actionPerformed == "manualMakeHost") {
                            console.log('data.actionPerformed 2.1 =>')
                            dispatch(clickAutoMakeHost({ clickedAutoMakeHost: false }, 'manualMakeHost auto_host_return self'));
                            // showAppToast(`You have opted to change the location of the mixer/host function for this session to reduce average latency. Please allow upto 30 seconds for this change to propagate.`, 15000);

                            showAppToast(`${ct("rta-trmc.premeeting.youHave")}  ${ct("Translate.messages.userMakeHostProcess")}`, 15000);

                            // fixme : currently loader is being hide by some other event even when current event is in processing, so showing loader 3 time after interval
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
                            }));

                            setTimeout(function () {
                                dispatch(showApiLoader({
                                    loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
                                }));
                            }, 2000);

                            setTimeout(function () {
                                dispatch(showApiLoader({
                                    loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
                                }));
                            }, 4000);
                        }

                        if (data.actionPerformed == "autoMakeHostRequest") {
                            console.log('data.actionPerformed 2.2 =>')
                            dispatch(setHostButtonAction(true))
                            showAppToast(`${ct("rta-trmc.premeeting.ManageHostWillStart")}`, 15000);
                        }
                    } else if (data.hasOwnProperty("onlyForModerator")) {
                        try {
                            console.log('data.actionPerformed exception case =>', data.actionPerformed, data.jitsiId, getLocalParticipant.id)
                        } catch (e) {
                            console.log("exception error ", e)
                        }

                        if (isModerator
                            && data.hasOwnProperty("authorizedUser")
                            && data.hasOwnProperty("newHostUser")) {
                            this.setState({
                                showConfirmModal: true,
                                transition: TransitionRight,
                                remoteUserInfo: {
                                    authorizedUser: data.authorizedUser,
                                    newHostUser: data.newHostUser
                                }
                            })
                        }
                    }

                    // flush above state after 40 sec
                    setTimeout(() => {
                        dispatch(setHostButtonAction(false))
                    }, 40000);
                } else {

                    // do nothing just show the modal to moderator
                    if (data.hasOwnProperty("onlyForModerator")) {
                        if ((data.location == CURRENT_ROOM_LOCATION
                            || roomorIpAddress == data.room)
                            && !usersData
                            && isModerator
                            && data.hasOwnProperty("authorizedUser")
                            && data.hasOwnProperty("newHostUser")
                        ) {
                            if (!_ValidateIPaddress(CURRENT_ROOM_NAME)) {
                                localStorage.removeItem("uniqueID")
                                this.setState({
                                    showConfirmModal: true,
                                    transition: TransitionRight,
                                    remoteUserInfo: {
                                        authorizedUser: data.authorizedUser,
                                        newHostUser: data.newHostUser
                                    }
                                })
                            }
                        }
                    }
                }
            }
        })

        socketOn("manage_host_rooms_return", data => {
            try {
                const { roomorIpAddress } = this.props
                console.log('manage_host_rooms_return => received inside ', data, CURRENT_ROOM_NAME, roomorIpAddress, "state ", this.state.showConfirmModal)
                if (data.currentRoom == CURRENT_ROOM_NAME || data.currentRoom == roomorIpAddress) {
                    if (this.state.showConfirmModal) {
                        dispatch(setHostButtonAction(true))
                        this.setState({
                            isUserConfirmed: false,
                            showConfirmModal: false
                        })
                        setTimeout(() => {
                            dispatch(setHostButtonAction(false))
                        }, 40000);
                    }
                }
            } catch (e) {
                console.log("manage_host_rooms_return error =>", e)
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            usersData,
            hostTabData,
            clickedAutoMakeHost,
            _isLiveStreamRunning,
            _isRecordingRunning,
            autoManageHostTrigger,
            conferenceJoined,
            roomorIpAddress,
            localUser,
            hostButtonAction
        } = this.props;

        let {
            isUserConfirmed
        } = this.state;


        if (prevProps.hostButtonAction != hostButtonAction) {
            if (hostButtonAction) {
                this.setState({
                    isUserConfirmed: false,
                    showConfirmModal: false
                })

                setTimeout(() => {
                    dispatch(setHostButtonAction(false))
                }, 40000);
            }
        }

        // Auto Manage Host Off

        // if (prevProps.conferenceJoined != conferenceJoined) {
        //     if (conferenceJoined) {
        //         let _this = this;
        //         setTimeout(() => {
        //             let roomParticipants = _this.props.participantCount;
        //             console.log("local particiants in the room", roomParticipants);
        //             if (roomParticipants == 1) {
        //                 let selectAutoHostCheckbox = getBaseConfig("selectAutoHostCheckbox");
        //                 console.log("Im single user in the room b", selectAutoHostCheckbox);
        //                 if (selectAutoHostCheckbox) {
        //                 console.log("Im single user in the room c, manage host is active now");
        //                 dispatch(clickAutoMakeHost({ clickedAutoMakeHost: true }, 'Manage Host did update'));
        //                 }
        //             }
        //         }, 2000);
        //     }
        // }

        // Auto Manage Host Off End
        // console.log("usersData manage host ", usersData, "hosted tab data ", hostTabData)
        // Auto Manage Host will start when hostTabData is changed
        if (usersData && prevProps.hostTabData != hostTabData) {
            console.log("host data changed", prevProps.hostTabData, "hostTabData ", hostTabData)
            if (hostTabData) {
                // to check if host tab data is changed, some time if data is same it will ignoring the prev and next props check
                // here we checking if users are changed in prev and next data based on flag
                //monitorHostTabChange if false above case will not work
                if (getBaseConfig("monitorHostTabChange") == true) {
                    try {
                        console.log("host data changed A")

                        if (prevProps.hostTabData?.users && hostTabData?.users) {
                            console.log("host data changed B", prevProps.hostTabData?.users, "hostTabData?.users", hostTabData?.users)

                            let isSame = _.isEqual(prevProps.hostTabData.users, hostTabData.users)
                            console.log("host data changed C", isSame)
                            if (isSame) {
                                return false;
                            }
                        }
                    } catch (e) {
                        console.log("host data changed errror", e)
                    }
                }

                console.log("host data process running")

                let willMove = false;
                if (!_isLiveStreamRunning && !_isRecordingRunning) {
                    // detect recommended host and will move if auto host check box is enabled
                    if (clickedAutoMakeHost) {
                        willMove = true;
                    }
                    // detect recommended host without if checkbox is off
                    if (getBaseConfig("detectRecommendedHost") == true) {
                        willMove = true;
                    }
                }

                // if (clickedAutoMakeHost && !_isLiveStreamRunning && !_isRecordingRunning) {
                if (willMove) {
                    let _this = this;
                    setTimeout(() => {
                        console.log("prevProps.clickedAutoMakeHost ", prevProps.clickedAutoMakeHost)
                        let clickedAutoMakeHost = getStore(FEATURE_CUSTOM_REDUX).clickedAutoMakeHost;
                        // console.log('clickedAutoMakeHost hostTabData start =>', clickedAutoMakeHost)
                        // if (clickedAutoMakeHost) {
                        //     console.log('clickedAutoMakeHost hostTabData start inside =>')
                        //     _this.autoMakeHostRequest();
                        // } else {
                        // }
                        let store_v3 = getStore(FEATURE_CUSTOM_REDUX_V3);

                        if (store_v3.isEventRequestingLoader == "") {
                            _this.autoMakeHostRequest(false);
                        }

                    }, 10000)
                }
            }
        }

        // Auto Manage Host will start whenever checkbox is checked (if hostTabData is there)
        if (usersData && prevProps.clickedAutoMakeHost != clickedAutoMakeHost) {
            if (hostTabData) {

                let _willMove = false;
                if (!_isLiveStreamRunning && !_isRecordingRunning) {
                    if (clickedAutoMakeHost) {
                        _willMove = true;
                    }
                    if (getBaseConfig("detectRecommendedHost") == true) {
                        _willMove = true;
                    }
                }

                // if (clickedAutoMakeHost && !_isLiveStreamRunning && !_isRecordingRunning) {
                if (_willMove) {
                    let _this = this;
                    setTimeout(() => {
                        let clickedAutoMakeHost = getStore(FEATURE_CUSTOM_REDUX).clickedAutoMakeHost;
                        console.log('clickedAutoMakeHost checkbox start =>', clickedAutoMakeHost)
                        if (clickedAutoMakeHost) {
                            console.log('clickedAutoMakeHost checkbox start inside =>')
                            _this.autoMakeHostRequest(false, true);
                        }
                    }, 10000)
                }
            }
        }

        if (prevProps.usersData != usersData) {
            if (usersData == null) {
                console.log("my box is disconnected now")
                if (conferenceJoined) {
                    dispatch(setHostTabData({
                        users: []
                    }))
                }
                this.handleHide()
            }
        }
        // remove local unique_id after 45s if device not connected
        if (prevProps.conferenceJoined != conferenceJoined) {
            if (conferenceJoined) {
                setTimeout(() => {
                    if (!usersData) {
                        localStorage.removeItem("uniqueID")
                    }
                }, 45000)
            }
        }
    }

    makeHostMessages = (data) => {
        dispatch(setIsEventRequestingLoader('manualMakeHostReceived'))

        // showAppToast(`${data.actionByUser} has opted to change the location of the mixer/host function for this session to reduce average latency. Please allow upto 30 seconds for this change to propagate.`, 15000);
        showAppToast(`${data.actionByUser} ${ct("rta-trmc.mixer.you")} ${ct("Translate.messages.userMakeHostProcess")}`, 15000);

        // fixme : currently loader is being hide by some other event even when current event is in processing, so showing loader 3 time after interval
        dispatch(showApiLoader({
            loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
        }));

        setTimeout(function () {
            dispatch(showApiLoader({
                loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
            }));
        }, 2000);

        setTimeout(function () {
            dispatch(showApiLoader({
                loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
            }));
        }, 4000);

        setTimeout(() => {
            dispatch(hideApiLoader())
            dispatch(setIsEventRequestingLoader(''))
        }, 60000)
    }

    autoMakeHostRequest(flushState = false, autoTrigger = false) {
        console.log('ManageHost->_selectAutoMakeHost->e->action =>', this.state, "willMove ", autoTrigger, "flushState", flushState);
        const {
            usersData,
            roomorIpAddress,
            hostTabData,
            isRecording,
            isStreaming,
            localUser,
            conferenceJoined,
            clickedAutoMakeHost,
            isModerator
        } = this.props;

        function getFirstUser() {
            let firstUserSort = hostTabData?.users;
            console.log('amh 7 =>', firstUserSort)
            firstUserSort.sort(function (a, b) {
                if (a.uniqueId < b.uniqueId) {
                    return -1;
                }
                if (a.uniqueId > b.uniqueId) {
                    return 1;
                }
                return 0;
            });
            // get first user who can hit the request
            let userWhoHit = firstUserSort[0];

            return userWhoHit
        }

        if (_ValidateIPaddress(CURRENT_ROOM_NAME)) {
            try {
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: "auto-make-host-event",
                    requestData: {
                        roomname: CURRENT_ROOM_NAME,
                        roomorIpAddress,
                        usersData,
                        type: 1 // stop auto manage host in IP case

                    },
                    responseData: '',
                    userId: '',
                    boxId: usersData.uniqueId,
                    message: 'Emit to server'
                }
                SaveLog(log_data);
            } catch (e) {

            }

            console.log("Current room is IP, but auto make host will not work")
            return false;
        }

        if (isRecording && isRecording > 0) {
            return false;
        } else if (isStreaming && isStreaming > 0) {
            return false;
        }

        if (!conferenceJoined) {
            return false;
        }

        let validIpRoom = _ValidateIPaddress(roomorIpAddress)

        let authorizedUser; // user who will hit api
        let newHostUser; // user who will next host

        if (validIpRoom) {
            // if current host is third party room,
            authorizedUser = hostTabData?.users?.find(o => o.isRecommended == true);
            newHostUser = hostTabData?.users?.find(o => o.isRecommended == true);
        } else {
            // if self host room
            authorizedUser = hostTabData?.users?.find(o => o.isRecommended == false && o.isHost == true);
            newHostUser = hostTabData?.users?.find(o => o.isHost == false && o.isRecommended == true);
        }
        // run flow with remote user's data received
        if (!authorizedUser && !newHostUser) {
            let remoteUserInfo = this.state.remoteUserInfo
            if (Object.keys(remoteUserInfo.authorizedUser).length) {
                if (remoteUserInfo.hasOwnProperty("authorizedUser") && remoteUserInfo.hasOwnProperty("newHostUser")) {
                    authorizedUser = remoteUserInfo.authorizedUser
                    newHostUser = remoteUserInfo.newHostUser
                }
            }
        }

        console.log("manage host check point 1 exising", this.state.isUserConfirmed, " =< isUserConfirmed", this.state.showConfirmModal, "<= showConfirmModal", authorizedUser, "newHostUser", newHostUser)
        if (flushState) {
            if (this.state.isUserConfirmed) {
                setTimeout(() => {
                    this.setState({
                        isUserConfirmed: false,
                        remoteUserInfo: {
                            authorizedUser: {},
                            newHostUser: {}
                        }
                    })
                }, 5000)
            }
        }


        if (authorizedUser) {
            try {
                console.log("authorizedUser", authorizedUser, "newHostUser", newHostUser)

                if (newHostUser.isHost == true) {
                    console.log("new  newHostUser is also host stopping here A")
                    return false;
                }

                // if (newHostUser?.uniqueId == usersData?.uniqueId && usersData?.isHost) {
                //     console.log("authorizedUser user and new  newHostUser are same so stopping here")
                //     return false;
                // }
            } catch (e) {
                console.log("new  newHostUser is also host stopping here error ", e)
            }

            let canAllMakeHost = false;
            // show the modal to each users or is authorize user
            // if (getBaseConfig("canAllUserMakeHost") == true || authorizedUser?.uniqueId == usersData?.uniqueId) {
            if ((clickedAutoMakeHost && authorizedUser?.uniqueId == usersData?.uniqueId) || flushState) {
                canAllMakeHost = true
            }
            console.log("canAllMakeHost ", canAllMakeHost)

            // if only moderators can view the modal to make host

            if (getBaseConfig("moderatorCanMakeHost") == true && !clickedAutoMakeHost) {
                console.log("I user moderator", isModerator)
                // inform all the moderator to show the make host confirmation model
                // but if all connected users are moderators and they will not set any event
                if (!isModerator) {
                    if (!flushState) {
                        socketEmit("auto_host", {
                            onlyForModerator: true,
                            room: roomorIpAddress,
                            location: CURRENT_ROOM_LOCATION,
                            authorizedUser,
                            newHostUser,
                            autohost: clickedAutoMakeHost
                        })
                        if (!usersData) {
                            setTimeout(() => {
                                dispatch(hideApiLoader())
                            }, 15000)
                        }
                    }
                    return false;
                } else {
                    // if all users are moderator then send this event by authorise user
                    if (usersData) {

                        let _move = false;
                        if (authorizedUser.hasOwnProperty("uniqueId")) {
                            if (authorizedUser?.uniqueId == usersData?.uniqueId) {
                                _move = true
                            }
                        } else {
                            let firstUser = getFirstUser();
                            console.log("i will move make host  A", firstUser, "usersDatausersData ", usersData?.uniqueId)

                            if (firstUser?.uniqueId == usersData?.uniqueId) {
                                _move = true
                            }
                        }
                        console.log("i will move make host ", _move)
                        // if (authorizedUser?.uniqueId == usersData?.uniqueId) {
                        if (_move) {
                            socketEmit("auto_host", {
                                onlyForModerator: true,
                                room: roomorIpAddress,
                                location: CURRENT_ROOM_LOCATION,
                                authorizedUser,
                                newHostUser,
                                autohost: clickedAutoMakeHost,
                                triggeredBy: "moderator"
                            })
                            if (!usersData) {
                                setTimeout(() => {
                                    dispatch(hideApiLoader())
                                }, 15000)
                            }
                        }
                    }
                }
            }
            // show modal to user to run the make host process(if enabled will show modal else it will work based on authorize user)
            if (getBaseConfig("confirmUserToAutoHost") == true) {
                // if (authorizedUser?.uniqueId == usersData?.uniqueId) {
                if (canAllMakeHost || isModerator) {
                    console.log("manage host check point 2 exising", this.state.isUserConfirmed, " =< isUserConfirmed", this.state.showConfirmModal, "<= showConfirmModal", "clickedAutoMakeHost ", clickedAutoMakeHost, "waitConfirm ")
                    if (!this.state.isUserConfirmed && !clickedAutoMakeHost) {
                        this.setState({
                            showConfirmModal: true,
                            transition: TransitionRight
                        })

                        return false;
                    }
                }
            }

            var auto_host_data = {
                room: roomorIpAddress,
                location: CURRENT_ROOM_LOCATION,
                jitsiId: localUser?.id,
                actionByUser: localUser?.name,
                actionPerformed: "autoMakeHostRequest",
                setFrom: "18"
            }

            console.log('amh A =>', auto_host_data, "flushState ", flushState)

            if (flushState) {
                auto_host_data = Object.assign(auto_host_data, {
                    actionPerformed: "manualMakeHost",
                    setFrom: "25",
                    autohost: clickedAutoMakeHost
                })
                console.log('amh C =>', auto_host_data, "flushState ", flushState)

            }

            socketEmit("auto_host", auto_host_data);
            console.log('amh 0 =>', auto_host_data)

            // if (authorizedUser?.uniqueId == usersData?.uniqueId) {
            if (canAllMakeHost) {
                console.log('amh 1 =>')
                // if i'm the current user who will hit the api
                // is third party user recommended
                if (newHostUser?.isThirdParty) {
                    this.sendNewRoom(newHostUser.thirdParty, newHostUser.uniqueId, true)
                } else if (validIpRoom && !newHostUser?.isThirdParty) {
                    this.sendNewRoom(CURRENT_ROOM_NAME, newHostUser.uniqueId)
                } else {
                    this.sendNewRoom(roomorIpAddress, newHostUser.uniqueId)
                }
            } else {
                // if current host is IP and recommended user is also IP (third party)
                let thirdPartyValidRoom = roomorIpAddress;
                if (thirdPartyValidRoom) {
                    if (thirdPartyValidRoom.includes(":")) {
                        thirdPartyValidRoom = thirdPartyValidRoom.split(':');
                        thirdPartyValidRoom = thirdPartyValidRoom[0]
                    }
                }
                if (
                    authorizedUser.isRecommended &&
                    authorizedUser.isThirdParty &&
                    newHostUser.isRecommended &&
                    newHostUser.isThirdParty &&
                    newHostUser.thirdParty != thirdPartyValidRoom
                ) {
                    let firstUserSort = hostTabData?.users;
                    firstUserSort.sort(function (a, b) {
                        if (a.uniqueId < b.uniqueId) {
                            return -1;
                        }
                        if (a.uniqueId > b.uniqueId) {
                            return 1;
                        }
                        return 0;
                    });
                    // get first user who can hit the request
                    let userWhoHit = firstUserSort[0];

                    let _canAllMakeHost = false;
                    if (getBaseConfig("canAllUserMakeHost") == true || userWhoHit?.uniqueId == usersData?.uniqueId) {
                        _canAllMakeHost = true
                    }
                    console.log("_canAllMakeHost ", _canAllMakeHost)

                    // if (userWhoHit.uniqueId == usersData?.uniqueId) {
                    if (_canAllMakeHost) {
                        console.log('amh 9 =>')
                        this.sendNewRoom(newHostUser.thirdParty, newHostUser.uniqueId, true)
                    }
                }
            }
        }

        sendAnalytics({
            action: 'automanage-host-checkbox',
            source: "settings",
            category: "settings automanage host checkbox"
        });
    }

    callThirdPartyMakeHostApi(newRoomName) {
        const { roomorIpAddress, dispatch } = this.props;

        dispatch(showApiLoader({
            loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
        }));

        dispatch(thirdPartyMakeHostApi({
            roomName: roomorIpAddress,
            newRoomName: newRoomName,
            visibleRoom: CURRENT_ROOM_NAME
        }).then(res => {
            if (res.status == 1) {
            } else {
                dispatch(hideApiLoader());
            }
            return false;
        }))
    }

    callmakehostApi(newRoomName, newHostId) {
        const { roomorIpAddress, dispatch } = this.props;
        dispatch(showApiLoader({
            loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
        }));

        let url = `${Constant.App.ServerUrl}/make-host?room=${roomorIpAddress}&newhost=${newHostId}`;
        let noChangedRoomName = getBaseConfig('noChangedRoomName')

        if (noChangedRoomName == true && newRoomName) {
            url = `${Constant.App.ServerUrl}/make-host?room=${roomorIpAddress}&newhost=${newHostId}&newRoomName=${newRoomName}&visibleRoom=${CURRENT_ROOM_NAME}`
        }
        // else if (noChangedRoomName == true) {
        //     url = `${Constant.App.ServerUrl}/make-host?room=${roomorIpAddress}&newhost=${newHostId}&visibleRoom=${CURRENT_ROOM_NAME}`;
        // }
        // else if (newRoomName) {
        //     url = `${Constant.App.ServerUrl}/make-host?room=${roomorIpAddress}&newhost=${newHostId}&newRoomName=${newRoomName}`;
        // }

        dispatch(showApiLoader({
            loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
        }));

        axios.get(url).then(response => {
            if (noChangedRoomName == true && newRoomName) {
                if (_ValidateIPaddress(newRoomName)) {
                    if (newRoomName && newRoomName.indexOf("_") != -1) {
                        newRoomName = newRoomName.replace("_", ":")
                    }
                }
                dispatch(setRoomorIpAddress(newRoomName, 'managehost callmakehostApi'));
            }
            // else if (noChangedRoomName == true) {
            //     dispatch(setRoomorIpAddress(roomorIpAddress, 'managehost callmakehostApi'));
            // }
            return false;
        }).catch(error => {
            console.log("InvalidRequest makeHost :", error);
            dispatch(hideApiLoader());
        });
    }

    sendNewRoom = (roomName, newHostId, isIp = false) => {
        dispatch(showApiLoader({
            loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
        }));

        const { clickedAutoMakeHost,
            roomorIpAddress,
            localUser,
            usersData
        } = this.props;
        let canCheckRoom = true;

        if (getBaseConfig("makeHostChangeRoom") == false) {
            canCheckRoom = false;
        }

        try {
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: "auto-make-host-event",
                requestData: {
                    roomname: CURRENT_ROOM_NAME,
                    roomorIpAddress,
                    usersData,
                    newHostId,
                    isIp,
                    type: 2 // stop auto manage host in IP case
                },
                responseData: '',
                userId: '',
                boxId: usersData.uniqueId,
                message: 'Emit to server'
            }
            SaveLog(log_data);
        } catch (e) {

        }

        console.log("I will check room status B")

        axios.get(`${socket_endpoint + apiVersion}/roomStatus?room=${roomName}`)
            .then(response => {
                if (canCheckRoom) {
                    if (response && response.data && response.data.status) {
                        return false;
                    }
                }

                if (isIp) {
                    this.callThirdPartyMakeHostApi(roomName, newHostId);
                } else {
                    this.callmakehostApi(roomName, newHostId);
                }

            }).catch(error => {
                console.log("room status api catch =>", error);
            });
    }

    sendDataToSocket(message, additional = "") {
        sendData(message, additional);

    }

    handleClose = () => {
        this.setState({
            showConfirmModal: false
        })
    }

    handleSubmit = () => {
        this.setState({
            showConfirmModal: false,
            isUserConfirmed: true
        })

        let _this = this;
        setTimeout(function () {
            _this.autoMakeHostRequest(true)
        }, 1000)

        let {
            usersData
        } = this.props;

        if (usersData == null || !usersData) {
            setTimeout(() => {
                dispatch(hideApiLoader())
            }, 20000)
        }
    }

    autoRecommendedUI = () => {
        return <>
            <Snackbar
                open={this.state.showConfirmModal}
                // autoHideDuration={20000}
                onClose={this.handleHide}
                TransitionComponent={this.state.transition}
                ClickAwayListenerProps={{ onClickAway: () => null }}
            >
                <div
                    className="make-host-base-container"
                >
                    <p className='font16 mb-5' dangerouslySetInnerHTML={{ __html: ct("Translate.confirmMessages.autoManageHostUserConfirm") }} ></p>
                    <div className={"w-100 d-flex justify-content-between"}>
                        <Button
                            appearance="subtle"
                            className="submit-button login-btn-pass join-meeting-pass"
                            id="auto-make-host-u-submit"
                            onClick={() => this.handleSubmit()}
                        >{ct("Translate.buttonTitle.okSmall")}</Button>
                        <Button
                            appearance="subtle"
                            className="cancel-button pull-right"
                            onClick={() => this.handleClose()}
                            id="auto-make-host-u-cancel"
                        >{ct("Translate.buttonTitle.cancelSmall")}</Button>
                    </div>
                </div>
            </Snackbar>
        </>
    }

    handleShow = (Transition) => {
        this.setState({
            transition: Transition,
            showConfirmModal: true
        })
    }
    handleHide = () => {
        this.setState({
            showConfirmModal: false,
            transition: undefined
        })
    }

    render() {
        return (
            <>
                {this.autoRecommendedUI()}
            </>
        )
    }
}

function _mapStateToProps(state) {
    return {
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        textMessage: state['trmc/customLoader/modal'].textMessage,
        latencyData: state[FEATURE_CUSTOM_REDUX].latencyData,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        hostTabData: state[FEATURE_CUSTOM_REDUX].hostTabData,
        hostReload: state[FEATURE_CUSTOM_REDUX].hostReload,
        room: state[FEATURE_CUSTOM_REDUX].room,
        hostRefresh: state[FEATURE_CUSTOM_REDUX].hostRefresh,
        hostRefreshTimer: state[FEATURE_CUSTOM_REDUX].hostRefreshTimer,
        uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
        isConnectedAudioGhost: state[FEATURE_CUSTOM_REDUX].isConnectedAudioGhost,
        localUserName: state['features/base/participants'].local?.name,
        localUser: state['features/base/participants'].local,
        audioGhostId: state[FEATURE_CUSTOM_REDUX].audioGhostId,
        isHybridSession: state[FEATURE_CUSTOM_REDUX].isHybridSession,
        isRecording: state['features/recording']?.sessionDatas?.filter(e => e.mode == "file" && e.status == "on")?.length,
        isStreaming: state['features/recording']?.sessionDatas?.filter(e => e.mode == "stream" && e.status == "on")?.length,
        clickedAutoMakeHost: state[FEATURE_CUSTOM_REDUX].clickedAutoMakeHost,
        delayPanning: state[FEATURE_CUSTOM_REDUX].delayPanning,
        isHostInitWaiting: state[FEATURE_CUSTOM_REDUX].isHostInitWaiting,
        audioChannelSt: state[FEATURE_CUSTOM_REDUX].audioChannelSt,
        audioChannelConfig: state[FEATURE_CUSTOM_REDUX_V2].audioChannelConfig,
        deviceUserName: state[FEATURE_CUSTOM_REDUX_V2].deviceUserName,
        isModerator: isLocalParticipantModerator(state),
        _isLiveStreamRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.STREAM)),
        _isRecordingRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.FILE)),
        hostButtonAction: state[FEATURE_CUSTOM_REDUX_V2].hostButtonAction,
        outAutoManage: state[FEATURE_CUSTOM_REDUX_V2].outAutoManage,
        autoManageHostTrigger: state[FEATURE_CUSTOM_REDUX_V3].autoManageHostTrigger,
        getLocalParticipant: getLocalParticipant(state),
        conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
        participantCount: getParticipantCount(state),
        remoteParticipants: getRemoteParticipants(state)
    };
}

export default translate(connect(_mapStateToProps)(ManageHost));